/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as Joi from 'joi-browser';

import { withStyles } from '@material-ui/core/styles';
import Search from '@material-ui/icons/Search';

import Form from '../../../common/Form';
import { form as FormStyle } from '../../../style/form';

import configEnv from '../../../config';

const { PERSIST_KEY } = configEnv;

const styles = ({ typography, palette }) => FormStyle(typography, palette);

class DesktopAddressSearch extends Form {
    state = {
        data: {
            search: '',
        },
        errors: {},
    };

    schema = {
        search: Joi.any().optional(),
    };

    render() {
        const { classes, onChange, className } = this.props;
        return (
            <>
                <form className={`${classes.form} ${className}`}>
                    {this.renderInput({
                        name: 'search',
                        type: 'search',
                        length: 25,
                        adornment: <Search />,
                        adornmentPosition: 'icon-start',
                        onChangeHandler: onChange,
                        desktop: true,

                    })}
                </form>
            </>
        );
    }
}

DesktopAddressSearch.defaultProps = {
    className: '',
};

DesktopAddressSearch.propTypes = {
    className: PropTypes.string,
    classes: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
    const newState = state[PERSIST_KEY] ? state[PERSIST_KEY] : state;
    return {
        isReadyState: newState.isReadyState,
    };
};

export default connect(
    mapStateToProps,
    null,
)(withStyles(styles)(DesktopAddressSearch));
